import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";


import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EcommercePage from "../pages/Dashboard/EcommercePage.vue";

import LogoutPage from "../pages/LogoutPage.vue";

import PainelCliente from "../pages/cliente/Index.vue";
import PainelClienteLogin from "../pages/cliente/Login.vue";
import PainelClienteLoginExterno from "../pages/cliente/LoginExterno.vue";
import PainelClienteParceiro from "../pages/cliente/Parceiro.vue";
import PainelClienteVerContrato from "../pages/cliente/VerContrato.vue";
import PainelClienteAssinarContrato from "../pages/cliente/AssinarContrato.vue";
import PainelClienteAlterarSenha from "../pages/cliente/AlterarSenha.vue";

import PainelEmpresa from "../pages/empresa/Index.vue";
import EmpresaLoginExterno from "../pages/empresa/LoginExterno.vue";
import EmpresaAlterarSenha from "../pages/empresa/AlterarSenha.vue";

import ErrorPage from "../pages/ErrorPage.vue";



const routes: Array<RouteRecordRaw> = [
 
  {
    path: "/",
    name: "Home",
    component: PainelCliente,
  },

  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/reset-password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
  },
  {
    path: "/email-confirmation",
    name: "EmailConfirmationPage",
    component: EmailConfirmationPage,
  },


  {
    path: "/logout",
    name: "LogoutPage",
    component: LogoutPage,
  },

  {
    path: "/cliente",
    name: "PainelCliente",
    component: PainelCliente,
  },
  {
    path: "/cliente/login",
    name: "PainelClienteLogin",
    component: PainelClienteLogin,
  },
  {
    path: "/cliente/parceiro/:parceiroId",
    name: "PainelClienteParceiro",
    component: PainelClienteParceiro,
  },
    {
    path: "/cliente/verContrato/:contratoId",
    name: "PainelClienteVerContrato",
    component: PainelClienteVerContrato,
  },
  {
    path: "/cliente/assinarContrato/:contratoId",
    name: "PainelClienteAssinarContrato",
    component: PainelClienteAssinarContrato,
  },
  {
    path: "/cliente/alterarSenha",
    name: "PainelClienteAlterarSenha",
    component: PainelClienteAlterarSenha,
  },
  {
    path: "/cliente/loginexterno",
    name: "PainelClienteLoginExterno",
    component: PainelClienteLoginExterno,
  },

  {
    path: "/empresa",
    name: "PainelEmpresa",
    component: PainelEmpresa,
  },
  {
    path: "/empresa/alterarsenha",
    name: "EmpresaAlterarSenha",
    component: EmpresaAlterarSenha,
  },
  {
    path: "/empresa/loginexterno",
    name: "EmpresaLoginExterno",
    component: EmpresaLoginExterno,
  },

  // Rota catch-all para páginas não encontradas (deve estar sempre por último)
  { 
    path: '/:catchAll(.*)', 
    name: 'NotFound',
    component: ErrorPage,
    meta: { title: 'Página não encontrada' }
  }

];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  console.log("Navegando para:", to.path);
  
  // Páginas que não precisam de autenticação
  const paginasPublicas = ["/login", "/cliente/login", "/cliente/loginexterno", "/Cliente/LoginExterno", "/empresa/loginexterno", "/Empresa/LoginExterno"];
  
  // Se é uma página pública, permitir acesso
  if (paginasPublicas.includes(to.path)) {
    console.log("Página pública, permitindo acesso");
    return next();
  }
  
  // Tratamento especial para rotas não encontradas
  if (to.name === 'NotFound') {
    console.log("Rota não encontrada:", to.params.catchAll);
    return next();
  }
  
  // Para outras páginas, verificar se o usuário (cliente ou empresa) está logado
  const user = localStorage.getItem("user");
  const empresaUser = localStorage.getItem("empresaUser");

  if ((user && user !== "") || (empresaUser && empresaUser !== "")) {
    console.log("Usuário autenticado, permitindo acesso");
    return next();
  } else {
    console.log("Usuário não autenticado, redirecionando para login");
    return next("/cliente/login");
  }
});

export default router;